<template class="full-height">
  <div class="member-container full-height">
    <el-dialog
      :top="dialogTopMargin"
      v-loading="listLoading"
      :visible.sync="dialogMemberFormVisible"
      :title="roleSettingObj.id ? `編輯帳號` : '新增帳號'"
      width="90%"
    >
      <el-row :gutter="24">
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-alert
                :closable="false"
                title="密碼為使用不可逆的加密演算法，無法查詢，只能設定新密碼"
                type="warning"
                effect="dark"
                style="color: #4b4b4b"
              >
              </el-alert>
            </div>
            <el-form
              :rules="rules"
              ref="memberForm"
              :model="roleSettingObj"
              :label-width="formLabelWidth"
            >
              <el-form-item :label="'負責國家區域'" prop="countryAreaList">
                <el-cascader
                  collapse-tags
                  v-model="roleSettingObj.countryAreaList"
                  :props="{
                    expandTrigger: 'hover',
                    multiple: true,
                  }"
                  style="width: 100%"
                  placeholder="預設為全選"
                  filterable
                  :options="travelAttractionsMenu"
                >
                </el-cascader>
              </el-form-item>

              <el-form-item :label="'角色設定'" prop="role">
                <el-select
                  v-model="roleSettingObj.role"
                  v-if="agencyRoleList && agencyRoleList.length > 0"
                  placeholder="請選擇"
                >
                  <el-option
                    v-for="item in agencyRoleList"
                    :key="item.roleCode"
                    :label="item.roleName"
                    :value="item.roleCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="'帳號'" prop="account">
                <el-input
                  v-model="roleSettingObj.account"
                  placeholder="帳號只限輸入英文小寫或數字"
                ></el-input>
              </el-form-item>

              <el-form-item :label="'姓名'" prop="name">
                <el-input v-model="roleSettingObj.name" placeholder="請輸入姓名"></el-input>
              </el-form-item>

              <el-form-item :label="'Email'" prop="mail">
                <el-input v-model="roleSettingObj.mail" placeholder="請輸入Email"></el-input>
              </el-form-item>

              <!-- <el-form-item :label="'電話'" prop="mobile">
            <el-input
              v-model="roleSettingObj.mobile"
              placeholder="請輸入電話"
            ></el-input>
          </el-form-item> -->
              <!-- 
          <el-form-item :label="'生日'">
            <el-date-picker
              style="width: 100%"
              v-model="roleSettingObj.birthday"
              type="date"
              placeholder="請選擇生日"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item> -->

              <el-form-item label="狀態">
                <!-- <el-radio-group v-model="roleSettingObj.status">
              <el-radio :label="0">停用</el-radio>
              <el-radio :label="1">啟用</el-radio>
            </el-radio-group> -->
                <el-switch
                  v-model="roleSettingObj.status"
                  active-text="停用"
                  inactive-text="啟用"
                  active-color="#ff4949"
                  inactive-color="#13ce66"
                  :active-value="0"
                  :inactive-value="1"
                >
                </el-switch>
              </el-form-item>

              <el-form-item :label="'密碼'" prop="pwd">
                <el-row>
                  <el-tag
                    type="warning"
                    style="height: auto; white-space: break-spaces; font-size: 14px"
                    >密碼原則：密碼必須包含英文，數字及長度介於6-16之間</el-tag
                  >
                </el-row>
                <el-button
                  style="margin-bottom: 5px"
                  v-if="roleSettingObj.id"
                  :type="showPwdInupt ? 'danger' : 'primary'"
                  size="mini"
                  @click="showPwdInuptHandler"
                  >{{ showPwdInupt ? '取消' : '更改密碼' }}</el-button
                >
                <el-input
                  v-if="!roleSettingObj.id || showPwdInupt"
                  v-model="roleSettingObj.pwd"
                  show-password
                ></el-input>
                <!-- <i style="color: #ccc; font-size: 12px; margin: 5px"
              >密碼原則：密碼必須包含英文，數字及長度介於6-16之間。</i
            > -->
              </el-form-item>
            </el-form>
            <div></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <div>
            <img :src="roleList" alt="roleList" fit="contain" width="100%" />
          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="saveData('memberForm')" style="color: #4b4b4b"
          >儲 存</el-button
        >
        <el-button @click="dialogMemberFormVisible = !dialogMemberFormVisible">取 消</el-button>
      </span>
    </el-dialog>

    <!-- <div style="padding-bottom: 0">
        <el-form :inline="true">
          <el-form-item label="搜尋">
            <el-input
              size="mini"
              v-model="listQuery.qry"
              placeholder="輸入查詢"
              @keyup.enter.native="handleFilter"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              size="mini"
              class="filter-item"
              type="primary"
              icon="el-icon-search"
              @click="handleFilter"
            >
              搜尋
            </el-button>

            <el-button type="success" size="mini" @click="addData"
              >建立</el-button
            >
          </el-form-item>

          <el-form-item>
            <el-button
              size="mini"
              style="cursor: pointer"
              v-loading="listLoading"
              type="success"
              icon="el-icon-refresh-left"
              circle
              @click="refresh()"
            ></el-button>
          </el-form-item>
        </el-form>
      </div> -->

    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.qry"
          placeholder="輸入關鍵字"
          @keyup.enter.native="handleFilter"
        />
      </el-form-item>

      <el-button
        type="primary"
        @click="handleFilter"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        type="warning"
        @click="addData"
        circle
        icon="el-icon-plus"
        :disabled="listLoading"
      ></el-button>
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        :key="tableKey"
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
        @sort-change="sortChange"
      >
        <!-- <el-table-column
            :label="'ID'"
            prop="id"
            sortable="custom"
            align="center"
            width="80"
          >
            <template slot-scope="{ row }">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column> -->

        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column
          :label="'帳號'"
          prop="account"
          sortable="custom"
          align="center"
          width="130"
        >
          <template slot-scope="{ row }">
            <span>{{ row.account }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column
            v-if="checkPermission(['ITA-DEV'])"
            :label="'auth'"
            prop="name"
            sortable="custom"
            align="center"
            width="130"
          >
            <template slot-scope="{ row }">
              <span>{{ row.name }}</span>
            </template>
          </el-table-column> -->

        <el-table-column :label="'姓名'" prop="name" sortable="custom" align="center" width="130">
          <template slot-scope="{ row }">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="狀態">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 0 ? 'danger' : 'success'">{{
              scope.row.status == 0 ? '停用' : '啟用'
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="角色">
          <template slot-scope="scope">
            <el-tag :type="scope.row.role | roleStyle">{{ scope.row.role | roleDesc }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="'編輯'">
          <template slot-scope="scope">
            <el-button size="mini" class="filter-item" type="success" @click="editData(scope.row)">
              編輯
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          :label="'刪除'"
          v-if="checkPermission(['ITA-DEV', 'ITA-TRAVEL-AGENCY'])"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              class="filter-item"
              type="danger"
              @click="deleteMember(scope.row)"
            >
              刪除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { getAgencyMembers, saveAgencyMemberData, deleteMember, getAgencyRoles } from '@/api/member'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // secondary package based on el-pagination
import { getTravelAttractionsCascaderMenu } from '@/api/travel'
import roleList from '@/assets/images/roleList.png'
import checkPermission from '@/utils/permission' // 权限判断函数

var defaultFormData = {
  account: null,
  agencyCode: null,
  // birthday: "1990-01-01",
  id: null,
  // mobile: null,
  name: null,
  roles: [],
  status: 1,
  countryAreaList: [],
}
export default {
  name: 'Member',
  components: { Pagination },
  directives: { waves },
  filters: {
    roleStyle(role) {
      const roleMap = {
        'AGENCY-NORMAL': 'info',
        'AGENCY-SENIOR': 'success',
        'AGENCY-FINANCIAL': 'danger',
      }
      return roleMap[role]
    },
    roleDesc(role) {
      console.log(role)
      const roleMap = {
        // "AGENCY-NORMAL": "旅行社-行政人員",
        // "AGENCY-SENIOR": "旅行社-高階主管",
        // "AGENCY-FINANCIAL": "旅行社-財務會計",
        'AGENCY-NORMAL': '旅行社-OP',
        'AGENCY-SENIOR': '旅行社-線控',
        'AGENCY-FINANCIAL': '旅行社-會計',
      }
      return roleMap[role]
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN'])) {
        let re = new RegExp(/^(?=.*\d)(?=.*[a-z]).{6,16}$/)
        if (!this.roleSettingObj.id && (!value || value === '')) {
          callback(new Error('請輸入密碼'))
        } else if (value.length > 0 && !re.test(value) && process.env.NODE_ENV != 'development') {
          callback(new Error('密碼請依照密碼原則建立!'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    // var validateMobile = (rule, value, callback) => {
    //   if (!checkPermission(["ITA-DEV", "APP-ADMIN", "ITA-ADMIN"])) {
    //     let re = new RegExp(/^09[0-9]{8}$/);
    //     if (value && value.length > 0 && !re.test(value)) {
    //       callback(new Error("手機號碼格式為:0911222333"));
    //     } else {
    //       callback();
    //     }
    //   } else {
    //     callback();
    //   }
    // };
    var validateMail = (rule, value, callback) => {
      let re = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      if (value && value.length > 0 && !re.test(value)) {
        callback(new Error('mail格式不正確'))
      } else {
        callback()
      }

      // if (!value || value === "") {
      //   callback(new Error("請輸入手機號碼"));
      // } else if (value.length > 0 && !re.test(value)) {
      //   callback(new Error("手機號碼格式為:0911222333"));
      // } else {
      //   callback();
      // }
    }
    return {
      roleList: roleList,
      agencyRoleList: [],
      travelAttractionsMenu: [],
      defaultCountryAreaList: [],
      rules: {
        pwd: [{ validator: validatePass, trigger: 'blur' }],
        account: [
          { required: true, message: '請輸入帳號', trigger: 'blur' },
          {
            required: true,
            pattern: /^[0-9a-z]*$/,
            message: '帳號格式不正確，只限輸入小寫英文或數字',
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
        // mobile: [{ validator: validateMobile, trigger: "blur" }],
        mail: [{ validator: validateMail, trigger: 'blur' }],
        role: [{ required: true, message: '請選擇角色', trigger: 'blur' }],
      },
      showPwdInupt: false,
      funcName: '帳號管理',
      dialogTopMargin: '2%',
      formLabelWidth: '120px',
      dialogMemberFormVisible: false,
      roleSettingObj: { countryAreaList: [], role: '' },
      rolesList: [],
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: null,
      dialogFormVisible: false,
      agencyCode: null,
    }
  },
  async created() {
    this.agencyCode = this.$store.getters.userInfo.agencyCode
    this.defaultListyQuerySetting()
    this.listQuery.agencyCode = this.agencyCode
    await this.getAgencyRoles()
    await this.getTravelAttractionsCascaderMenu()
    await this.getList()
  },
  methods: {
    async getAgencyRoles() {
      let resp = await getAgencyRoles()
      this.agencyRoleList = resp.data
    },
    defaultListyQuerySetting() {
      this.listQuery = {
        page: 1,
        limit: 30,
        importance: undefined,
        title: undefined,
        type: undefined,
        sort: '-cUpdateDT',
        agencyCode: this.agencyCode,
      }
    },
    async refresh() {
      this.defaultListyQuerySetting()
      await this.getList()
    },
    async getTravelAttractionsCascaderMenu() {
      let resp = await getTravelAttractionsCascaderMenu()
      //只需要到國家
      // if (resp.data) {
      //   resp.data.forEach((f) => {
      //     if (f.children) {
      //       f.children.forEach((c) => {
      //         c.children = null;
      //       });
      //     }
      //   });
      // }
      this.travelAttractionsMenu = resp.data

      // 建立地區預設值
      const countryAreaArray = []
      resp.data.forEach(region => {
        if (region.children) {
          region.children.forEach(country => {
            if (country.children) {
              country.children.forEach(city => {
                const arrayList = [
                  region.value.toString(),
                  country.value.toString(),
                  city.value.toString(),
                ]
                countryAreaArray.push(arrayList)
              })
            } else {
              const arrayList = [region.value.toString(), country.value.toString()]
              countryAreaArray.push(arrayList)
            }
          })
        } else {
          const arrayList = [region.value.toString()]
          countryAreaArray.push(arrayList)
        }
      })
      this.defaultCountryAreaList = countryAreaArray
    },
    async deleteMember(row) {
      let vm = this
      if (confirm(`確定刪除【${row.name}】使用者資訊?一但刪除連同旅客關聯檔也會一併刪除\r\n`)) {
        vm.loadingHanlder(true)
        let resp = await deleteMember({ id: row.id })
        if (resp.success) {
          await vm.getList()
          vm.$message({
            message: '操作成功',
            type: 'success',
          })
        }
        vm.loadingHanlder(false)
      }
    },
    showPwdInuptHandler() {
      this.showPwdInupt = !this.showPwdInupt
    },
    loadingHanlder(action) {
      let vm = this
      if (vm.listLoading != action) {
        vm.listLoading = action
      }
    },
    checkPermission,
    addData(row) {
      let vm = this
      vm.dialogMemberFormVisible = true
      vm.roleSettingObj = JSON.parse(JSON.stringify(defaultFormData))
      vm.roleSettingObj.countryAreaList = this.defaultCountryAreaList
    },
    editData(row) {
      let vm = this
      vm.dialogMemberFormVisible = true
      console.log(row)
      vm.roleSettingObj = row
    },
    async saveData(formName) {
      if (!confirm('確定儲存資料?')) {
        return
      }
      let vm = this
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.loadingHanlder(true)
          vm.roleSettingObj.agencyCode = vm.agencyCode
          try {
            let resp = await saveAgencyMemberData(vm.roleSettingObj)

            vm.getList()
            vm.dialogMemberFormVisible = false
            this.loadingHanlder(false)
            this.$message({
              message: '操作成功',
              type: 'success',
            })
          } catch (error) {
            console.log(error.response.data)
          } finally {
            this.loadingHanlder(false)
          }
        } else {
          return false
        }
      })
    },
    refreshSelectedTag(path) {
      this.$store.dispatch('tagsView/delCachedViewByName', 'ProductSalesanAlysis').then(() => {
        this.$nextTick(() => {
          this.$router.replace({
            path: path.replace('#', ''),
          })
        })
      })
    },
    async getList() {
      this.loadingHanlder(true)
      var resp = await getAgencyMembers(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.total
      this.loadingHanlder(false)
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.status = status
    },
    sortChange(data) {
      const { prop, order } = data
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
  },
}
</script>
<style scope>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding: 15px !important;
}
</style>
